export default __webpack_public_path__ + "static/media/ecosystem.4abd5dc8.png";